export default "__VITE_ASSET__DaZTdtiJ__"